<div class="terms-content mat-typography" >
  <h1 class="main-heading">{{ 'TERMS.MAIN_HEADING' | translate }}</h1>
  <p>{{ 'TERMS.FIRST_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.OVERVIEW' | translate }}</h3>
  <p>{{ 'TERMS.SECOND_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.FIRST' | translate }}</h3>
  <p>{{ 'TERMS.THIRD_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.SECOND' | translate }}</h3>
  <p>{{ 'TERMS.FOURTH_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.THIRD' | translate }}</h3>
  <p>{{ 'TERMS.FIFTH_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.SIGNUP_TITLE' | translate }}</h3>
  <ol>
    <li>{{ 'TERMS.SIGNUP_1' | translate }}</li>
    <li>{{ 'TERMS.SIGNUP_2' | translate }}</li>
    <li>{{ 'TERMS.SIGNUP_3' | translate }}</li>
    <li>{{ 'TERMS.SIGNUP_4' | translate }}</li>
    <li>{{ 'TERMS.SIGNUP_5' | translate }}</li>
  </ol>
  
  <h3>{{ 'TERMS.FREE_TRIAL_TITLE' | translate }}</h3>
  <ul>
    <li>{{ 'TERMS.FREE_TRIAL_1' | translate }}</li>
    <li>{{ 'TERMS.FREE_TRIAL_2' | translate }}</li>
  </ul>
  
  <h4>{{ 'TERMS.CANCEL_TITLE' | translate }}</h4>
  <p>{{ 'TERMS.CANCEL_INTRO' | translate }}</p>
  <ul>
    <li>{{ 'TERMS.CANCEL_1' | translate }}</li>
    <li>{{ 'TERMS.CANCEL_2' | translate }}</li>
  </ul>

  <h3>{{ 'TERMS.TERMINATE_TITLE' | translate }}</h3>
  <ul>
    <li>{{ 'TERMS.TERMINATE_1' | translate }}</li>
    <li>{{ 'TERMS.TERMINATE_2' | translate }}</li>
    <li>{{ 'TERMS.TERMINATE_3' | translate }}</li>
  </ul>
</div>
